export default __webpack_public_path__ + "static/media/pencil.cbfd41e3.svg";